export const Pattern: React.FC = () => (
  <svg
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    opacity="0.1"
  >
    <rect width="100%" height="100%" fill="url(#pattern-bg)" />
  </svg>
);
Pattern.displayName = 'SharedMY24Pattern';
